import React, { useState, useEffect, useRef } from "react";

import { Button, Select, MenuItem, Popper, Grow, Paper, ClickAwayListener, Link, MenuList, Grid, InputBase } from "@material-ui/core";

import Tooltip from '@material-ui/core/Tooltip';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
import { data as gridCnfg } from './setupData';

import Details from './../../assets/img/action/details.svg';
import MonthlyUsage from './../../assets/img/action/monthlyUsage.svg';
import Settings from './../../assets/img/action/settings.svg';
import ActionIcon from './../../assets/img/action/action.svg';
import ChangeName from './../../assets/img/action/changeName.svg';
import Reconnect from './../../assets/img/action/reconnect.svg';
import Disconnect from './../../assets/img/action/disconnect.svg';
import Suspend from './../../assets/img/action/suspend.svg';
import SimSwap from './../../assets/img/action/undo.svg';
import Usage from './../../assets/img/action/usage.svg';
import Forward from './../../assets/img/action/forward.svg';

import LoadingIcon from "./../../assets/img/icons/loaderIcon.gif";
import AddNotes from './../../assets/img/icons/addNotes.svg'
import ViewNotes from './../../assets/img/icons/eye.svg'
import NoRecord from "./../NoRecord/NoRecord";
import ListAltIcon from '@material-ui/icons/ListAlt';
import ViewActiveLog from './../../assets/img/icons/activeLog.svg'
import Edit from './../../assets/img/action/edit.svg'
import Delete from './../../assets/img/icons/Delete.svg';
import ReceiptIcon from '@material-ui/icons/Receipt';

import Print from './../../assets/img/action/Print.svg';
import Eyebold from './../../assets/img/action/eye-Bold.svg';
import Email from './../../assets/img/action/email.svg';
import { GetUserInfo } from "../../Services/GetUserInfo";
import Pen from './../../assets/img/action/pen.svg';
import { EyeOutlined } from '@ant-design/icons';

import { GetUserRolesRights } from '../../Services/GetUserRolesRights';
import { formatDate, numberDisplay } from '../../../src/components/Common/Extensions';

import { Table, Empty, Dropdown, message, Menu, Typography, Tag } from 'antd';

import useStyles from "./styles";
import './style.css';
import 'antd/dist/antd.css';

export default function SearchGrid({ onChange, selectedView, Icon, columns, onActionClick, isUpdate, onDeleteClick, onEditClick, list, isSearchAble, isTopPagination, onChangeSearchValue, isGridLoaded, resetPagination, ...props }) {
    const classes = useStyles();
    let user_info = JSON.parse(GetUserInfo());
    const [roleId, setRoleId] = useState(user_info.user.roleId);
    const [rowsData, setRowsData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isResetPagination, setIsResetPagination] = useState(false);
    const accessPermissionEnum = {
        NOTVISIBLE: 0,
        NOTEDITABLE: 1,
        EDITABLE: 2
    };
    let user_role_rights_list = JSON.parse(GetUserRolesRights());
    const [value, setValue] = useState('');

    const handleSearchChange = (currValue) => {


        const trimmedValue = currValue.trim()

        if (trimmedValue && trimmedValue != undefined && trimmedValue != null && trimmedValue != "") {

            if (onChangeSearchValue != undefined) {
                onChangeSearchValue(trimmedValue)
            }
            let filteredData = [];
            filteredData = [...list];
            filteredData = filteredData.filter(entry => {
                var hasValue = false;
                for (var prop in entry) {
                    if (Object.prototype.hasOwnProperty.call(entry, prop)) {
                        hasValue = entry[prop]?.toString().toLowerCase().includes(trimmedValue.toLowerCase());
                        if (hasValue)
                            break;
                    }
                }
                return hasValue;
            }
            );
            if (isGridLoaded) {
                setRowsData(filteredData);
            } else {
                loadGridData(filteredData);
            }
        } else {
            const filteredData = [...list];
            if (isGridLoaded) {
                setRowsData(filteredData);
            } else {
                loadGridData(filteredData);
            }

        }

        isGridLoaded = true;
    }
    const handleClearInput = (name) => {
        setValue('');
        handleSearchChange('');
    };
    const handleSearch = (e) => {
        const currValue = e.target.value;
        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleSearchChange(currValue);
        }
    }

    const [currentPage, setCurrentPage] = useState(1);
    // Define pagination configuration
    const paginationConfig = {
        position: [isTopPagination ? 'topRight' : '', 'bottomRight'],
        defaultPageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40],
        current: currentPage
    };
    const handleTableChange = (pagination) => {
        setCurrentPage(pagination.current);
    }
    useEffect(() => {
        if (props.filter !== undefined && props.filter != '') {
            handleSearchChange(props.filter);
        } else {
            loadGridData(list);
        }
        if (resetPagination !== isResetPagination) {
            setCurrentPage(1)
            setIsResetPagination(resetPagination)
        }

    }, [isUpdate, resetPagination]);

    const items = [
        { key: 'lineDetails', label: 'Line Details', icon: Details },
        { key: 'reconnect', label: 'Reconnect', icon: Reconnect },
        { key: 'restore', label: 'Restore', icon: Reconnect },
        { key: 'usage', label: 'Usage', icon: Usage },
        //{ key: 'monthlyUsage', label: 'Monthly Usage', icon: MonthlyUsage },
        { key: 'changePhoneNumber', label: 'Change Phone Number', icon: Settings },
        { key: 'changeLineName', label: 'Change Line Name', icon: ChangeName },
        { key: 'forwardNumber', label: 'Forward Number', icon: Forward },
        { key: 'stopForwardNumber', label: 'Stop Forward Number', icon: Forward },
        { key: 'suspendNumber', label: 'Suspend Number', icon: Suspend },
        // { key: 'customerNotes', label: 'Add Notes', icon: AddNotes },
        // { key: 'viewCustomerNotes', label: 'View Notes', icon: ViewNotes },
        { key: 'viewActivityLog', label: 'View Log', icon: ViewActiveLog },
        { key: 'simSwipe', label: 'SIM Swap', icon: SimSwap },
        { key: 'imeiCheck', label: 'IMEI Check', icon: Details },
        { key: 'disconnect', label: 'Disconnect', icon: Disconnect },
    ];


    const onClick = (key, item) => {
        if (onActionClick) {
            onActionClick(key, item);
        }
    };
    const loadGridData = (_filteredRecord) => {
        if (_filteredRecord) {
            setRowsData(
                _filteredRecord.map((item, i) => {
                    item.customerInformation = <div className={classes.customerInformation}>
                        <span>
                            <Typography component="h5">Full Name: </Typography>
                            <Typography component="p">{item.fullName}</Typography>
                        </span>
                        <span>
                            <Typography component="h5">Phone #:</Typography>
                            <Typography component="p">{item.phone}</Typography>
                        </span>
                        <span>
                            <Typography component="h5">Email :</Typography>
                            <Typography component="p">{item.email}</Typography>
                        </span>
                        <span>
                            <Typography component="h5">Address :</Typography>
                            <Typography component="p">{item.address}</Typography>
                        </span>
                    </div>
                    item.orderInformation = <div className={classes.orderInformation}>
                        <span>
                            <Typography component="h5">Order Date: </Typography>
                            <Typography component="p">{item.orderDate}</Typography>
                        </span>
                        <span>
                            <Typography component="h5">Figgers Account:</Typography>
                            <Typography component="p">{item.figgersAccount}</Typography>
                        </span>
                        <span>
                            <Typography component="h5">Billing Cycle:</Typography>
                            <Typography component="p">{item.billingCycle}</Typography>
                        </span>
                        <span>
                            <Typography component="h5">Plan:</Typography>
                            <Typography component="p">{item.plan}</Typography>
                        </span>
                    </div>
                    item.requestAction = <Button className={classes.requestActionBtn}>Process</Button>

                    item.orderStatus = <Tag className={classes.requestStatusTag}>{item.orderStatus}</Tag>

                    item.prepaidAction = <div className="textCenter">
                        <Dropdown overlay={<Menu>
                            {
                                items.map((menuItem, index) => {
                                    if (
                                        (item.status === 'Disconnected' && !['reconnect', 'lineDetails', 'customerNotes', 'viewCustomerNotes', 'viewActivityLog', 'bucketUpdate', 'addCash'].includes(menuItem.key))
                                        || (menuItem.key === 'restore' && item.status !== 'Suspended')
                                        || (menuItem.key === 'disconnect' && item.status === 'Disconnected')
                                        || (menuItem.key === 'suspendNumber' && item.status === 'Suspended')
                                        || (menuItem.key === 'reconnect' && item.status !== 'Disconnected')
                                        || (menuItem.key === 'forwardNumber' && (item.forwardToNumber || item.status == 'Inactive'))
                                        || (menuItem.key === 'stopForwardNumber' && (!item.forwardToNumber || item.status == 'Inactive'))
                                        || (menuItem.key === 'lineDetails' && (!user_role_rights_list || !user_role_rights_list.some(item => item.rightName === 'lineDetails' && item.permissionCode > 0)))
                                        || (['reconnect', 'restore', 'usage', 'monthlyUsage', 'changePhoneNumber', 'changeLineName', 'suspendNumber', 'forwardNumber', 'stopForwardNumber', 'customerNotes', 'viewCustomerNotes', 'viewActivityLog', 'simSwipe', 'imeiCheck', 'disconnect'].includes(menuItem.key) && (!user_role_rights_list || !user_role_rights_list.some(item => item.rightName === menuItem.key && item.permissionCode > 0)))
                                    )
                                        return null;
                                    else
                                        return (
                                            <Menu.Item
                                                onClick={() => onClick(menuItem.key, item)}
                                                key={menuItem.key}
                                                className={classes.DropdownItems}
                                            >
                                                <img src={menuItem.icon} alt={`${menuItem.label} icon`} />
                                                {menuItem.label}
                                            </Menu.Item>
                                        );
                                })
                            }
                        </Menu>} trigger={["click"]}
                            className={classes.actionDropDown}>
                            <Button className={classes.actionBtn} startIcon={<img src={ActionIcon} alt="action" />}>
                                Actions <ArrowDropDownIcon />
                            </Button>
                        </Dropdown>
                    </div>
                    item.postpaidAction = <div className="textCenter">
                        <Dropdown overlay={<Menu>
                            {
                                items.map((menuItem, index) => {
                                    return <Menu.Item
                                        onClick={() => onClick(menuItem.key, item)}
                                        key={menuItem.key}
                                        className={classes.DropdownItems}
                                    > <img src={menuItem.icon} /> {menuItem.label}
                                    </Menu.Item>
                                })
                            }
                        </Menu>} trigger={["click"]}
                            className={classes.actionDropDown}>
                            <Button className={classes.actionBtn} startIcon={<img src={ActionIcon} alt="action" />}>
                                Actions <ArrowDropDownIcon />
                            </Button>
                        </Dropdown>
                    </div>
                    item.receiptHTMLAction = <>
                        <div style={{ justifyContent: 'center', display: 'flex' }}>

                            <Tooltip title="View Receipt">
                                <ReceiptIcon style={{ color: 'rgb(98 163 213)', marginRight: '2px' }} onClick={() => onClick('ViewReceipt', item)} />

                            </Tooltip>
                            {/*<Tooltip title="View PDF">*/}
                            {/*    <img src={Eyebold}  onClick={() => onClick('ViewPDF', item)} />*/}
                            {/*</Tooltip>*/}
                            {/*<Tooltip title="Print Receipt">*/}
                            {/*     <img src={Print} width="22px"  onClick={() => onClick('PrintReceipt', item)} />*/}
                            {/*</Tooltip>*/}
                            {/*<Tooltip title="Email Receipt">*/}
                            {/*    <img src={Email} onClick={() => onClick('EmailReceipt', item)} />*/}

                            {/*</Tooltip>*/}
                        </div>
                    </>
                    item.action = <>
                        <div className={classes.linkContainer}>

                            <Tooltip title="Edit">
                                <Link to="/">
                                    <img src={Edit} onClick={() => onClick('Edit', item)} />
                                </Link>
                            </Tooltip>

                            <Tooltip title="Delete">
                                <Link to="/">
                                    <img src={Delete} onClick={() => onClick('Delete', item)} />
                                </Link>
                            </Tooltip>
                        </div>

                    </>
                    //item.customNote = <Tooltip title={item.customNote}>
                    //    <p className={classes.truncate}>{item.customNote}</p>
                    //</Tooltip>
                    item.customNoteHTML = <>
                        <Tooltip title="View Notes">
                            <img src={Eyebold} onClick={() => onClick('viewCustomerNotes', item)} />

                        </Tooltip>
                        {/* <Tooltip title={<p dangerouslySetInnerHTML={{
                            __html: item.customNote,
                        }}></p>}>
                            <p className={classes.truncate} dangerouslySetInnerHTML={{
                                __html: item.customNote,
                            }}></p>
                        </Tooltip> */}
                    </>
                    item.rolesAction = <>
                        <div className={classes.commonAction}>

                            {onDeleteClick &&
                                (item.accesPermission === accessPermissionEnum.EDITABLE ? (
                                    <Tooltip title="Delete">
                                        <img src={Delete} onClick={() => onDeleteClick(item)} />
                                    </Tooltip>
                                ) : (
                                    <img src={Delete} style={{ opacity: '50%', cursor: 'auto' }} />
                                ))}

                            {onEditClick &&
                                item.accesPermission === accessPermissionEnum.EDITABLE ?
                                    <Tooltip title="Edit">
                                        <img src={Pen} width="20px" onClick={() => { onEditClick(item) }} />
                                    </Tooltip> :
                                <Tooltip title="View">
                                    <EyeOutlined width="20px" className={classes.eyeButton} onClick={() => { onEditClick(item) }} />
                                    </Tooltip>
                                }

                        </div>

                    </>
                    item.userActions = <>
                        <div className={classes.commonAction}>

                            {/*{onDeleteClick ?*/}
                            {/*    <Tooltip title="Delete">*/}
                            {/*        <img src={Delete} onClick={() => { onDeleteClick(item) }} />*/}
                            {/*    </Tooltip> :*/}
                            {/*    ''}*/}

                            {/*{onEditClick ?*/}
                            {/*    <Tooltip title="Edit">*/}
                            {/*        <img src={Pen} width="20px" onClick={() => { onEditClick(item) }} />*/}
                            {/*    </Tooltip> :*/}
                            {/*    ''}*/}

                            {onDeleteClick &&
                                (item.roleCode != 'corporate_admin' ? (
                                    <Tooltip title="Delete">
                                        <img src={Delete} onClick={() => onDeleteClick(item)} />
                                    </Tooltip>
                                ) : (
                                    <img src={Delete} style={{ opacity: '50%', cursor: 'auto' }} />
                                ))}

                            {onEditClick &&
                                (item.roleCode != 'corporate_admin' ? (
                                    <Tooltip title="Edit">
                                        <img src={Pen} width="20px" onClick={() => { onEditClick(item) }} />
                                    </Tooltip>
                                ) : (
                                    <img src={Pen} style={{ opacity: '50%', cursor: 'auto' }} />
                                ))}

                        </div>
                    </>
                    item.commonAction = <>
                        <div className={classes.commonAction}>

                            {onDeleteClick ?
                                <Tooltip title="Delete">
                                    <img src={Delete} onClick={() => { onDeleteClick(item) }} />
                                </Tooltip> :
                                ''}

                            {onEditClick ?
                                <Tooltip title="Edit">
                                    <img src={Pen} width="20px" onClick={() => { onEditClick(item) }} />
                                </Tooltip> :
                                ''}

                        </div>

                    </>
                    item.statusCol = <div className="statuses"><span className={
                        item.status === "Active" ? 'activeStatus' :
                            item.status === "Inactive" ? 'inActiveStatus' :
                                item.status === "Suspended" ? 'SuspendedStatus' :
                                    item.status === "Disconnected" ? 'disconnectStatus' :
                                        item.status === "Hotlined" ? 'hotlineStatus' : ''


                    }> {item.status}</span >
                    </div>
                    { item.formattedAmount = columns == 'paymentHistory' ? numberDisplay(item.amount, 2, 2, 0) : '' }
                    item.corporateOwnerIdentifier =
                        <>
                            <Tooltip
                                title={
                                    item.isCorporateOwner
                                        ? 'Corporate Owner'
                                        : null
                                }
                            >
                                <div
                                    className={
                                    item.isCorporateOwner
                                        ? 'corporateOwner'
                                            : null
                                    }
                                ></div>
                            </Tooltip>
                        </>

                    return { ...item }
                }
                ));
        }

    }
    return (
        <>
            {
                isSearchAble ?
                    <Grid container item direction="row" xs={12} sm={12} md={12} lg={12} xl={12} style={{ margin: '5px 0px' }}>
                        <Grid container item direction="row" xs={3} sm={3} md={3} lg={3} xl={3} style={{ marginLeft: 'auto' }}>
                            <InputBase
                                value={value}
                                placeholder="Search"
                                className="grid-search-input"
                                startAdornment={<SearchIcon />}
                                endAdornment={value ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                                onChange={handleSearch}
                            />
                        </Grid>
                    </Grid>
                    :
                    ""
            }
            <div className="custom-grid">
                <Table
                    rowKey={(record) => {
                        const keys = Object.keys(record);
                        return record[keys[0]];
                    }}
                    locale={{
                        emptyText: (
                            <Empty
                                image={isLoading && LoadingIcon}
                                description={isLoading ? "Loading..." : <> <NoRecord Icon={Icon} message={props.noRecordMsg}></NoRecord> </>}
                                imageStyle={{ height: 30, display: !isLoading ? "none" : "" }}
                            />
                        )
                    }}
                    checkStrictly={true}
                    rowClassName={(record, index) => "claimRow"}
                    scroll={true}
                    pagination={paginationConfig}
                    dataSource={rowsData}
                    columns={gridCnfg[columns]}
                    size="small"
                    onChange={handleTableChange}
                />
            </div>
        </>
    );
}